var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g({attrs:{"icon":""},on:{"click":_vm.open}},on),[_c('v-icon',[_vm._v("fa fa-images")])],1)]}}])},[_c('span',[_vm._v(_vm._s(_vm._f("t")('photo_manager')))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }